<template>
  <div>
    <v-btn color="primary" @click="dialog = true">  <v-icon>arrow_downward</v-icon>Download Chat</v-btn>
    <v-dialog v-model="dialog" width="500" >
      <v-card>
        <v-card-title>
          Download Chat Data
        </v-card-title>
        <v-card-text >
            <v-menu
              ref="menuFrom"
              v-model="menuFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <label for="">From</label>
                <v-text-field
                  v-model="from"
                  outline
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="from" no-title @input="menuFrom = false"></v-date-picker>
            </v-menu>
            <v-menu
              ref="menuFrom"
              v-model="menuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <label for="">To</label>
                <v-text-field
                  v-model="to"
                  outline
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="to" no-title @input="menuTo = false" :min="from"></v-date-picker>
            </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :loading="loader"
            @click="downloadChat">
            Download
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "donwloadChat",
    data() {
      return {
        loader: false,
        dialog: false,
        menuFrom: '',
        menuTo: '',
        from: '',
        to: ''
      }
    },
    methods: {
      downloadChat () {
        this.loader = true
        window.open(`${process.env.VUE_APP_SESSION_MANAGER_BASE_URL}/bots/${this.$store.state.bot.botId}/download-all-chats?from=${this.from}&to=${this.to}`)
        this.dialog = false
        this.loader = false
      }
    }
  }
</script>

<style scoped>

</style>
